/*
  ArmeSiMunitie: Microsoft Clarity custom events, so recordings and the
  dashboard can be filtered by what visitors actually did. Uses the Clarity
  queue stub, so it works whether the Clarity tag loads before or after this
  file; does nothing harmful if Clarity is not installed.
  Events: ams_add_to_cart, ams_buy_now, ams_checkout, ams_whatsapp,
  ams_whatsapp_share, ams_phone, ams_load_more, ams_quote.
*/
(function() {
  window.clarity = window.clarity || function() { (window.clarity.q = window.clarity.q || []).push(arguments); };

  var sent = {};
  function track(name, once) {
    if (once && sent[name]) return;
    sent[name] = true;
    try {
      window.clarity('event', name);
      window.clarity('set', 'ams_last_action', name);
    } catch (e) {}
  }
  window.amsTrack = track;


  document.addEventListener('submit', function(evt) {
    var form = evt.target;
    if (!form || !form.getAttribute) return;
    var action = form.getAttribute('action') || '';
    if (/\/cart\/add/.test(action)) track('ams_add_to_cart');
  }, true);

  document.addEventListener('click', function(evt) {
    var t = evt.target;
    if (!t || !t.closest) return;
    if (t.closest('.shopify-payment-button')) { track('ams_buy_now'); return; }
    if (t.closest('button[name="checkout"], input[name="checkout"], a[href="/checkout"]')) { track('ams_checkout'); return; }
    if (t.closest('[data-ams-load-more-btn]')) { track('ams_load_more'); return; }
    var a = t.closest('a[href]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (/wa\.me\/\?text=/.test(href)) track('ams_whatsapp_share');
    else if (/wa\.me\/|api\.whatsapp\.com|whatsapp:/.test(href)) track('ams_whatsapp');
    else if (/^tel:/.test(href)) track('ams_phone');
    else if (/\/pages\/(oferta-la-cerere|contact)/.test(href)) track('ams_quote');
  }, true);
})();
